import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from 'src/app/shared/utils/config.service';
import { GridFilterModel } from 'src/app/shared/models/grid-filter.model';
import { RegistrationFormModel } from '../models/registration-form.model';

@Injectable({
  providedIn: 'root'
})
export class SmatNasaService {


  apiUrl: string = '';
  baseApiUrl: string = '';
  apiUrlRm: string = '';
  apiUrlPayment: string = '';
  apiUrlZc: string = '';
  apiUrlUnit: string = '';
  apiUrlZenith: string = '';
  apiUrlZenithTransfer: string = '';
  apiUrlApplicationForm: string = '';
  clientId: number = 0;
  photourl: string = '';
  apiUrlPaymentStatus: string = '';
  apiUrlAppForm: string;
  apiUrlRegistrationForm: string = '';
  apiUrlApplicationFormGet: string = '';
  apiUrlApplicationFormGetById: string = '';
  apiUrlApplicationFormGetByUserName: string = '';
  apiUrlGetLGA: string = '';
  apiUrlNINVerify: string = '';
  apiUrlComapnyVerify: string = '';
  apiUrlApplicationFormGetData: string = '';
  apiUrlBillingForm: string = '';
  apiUrlBillingFormGetById: string = '';
  apiApprovalUrl: string='';
  apiRejectUrl: string='';
  apiSendEmailUrl: string='';
  apiSendSMSUrl: string = '';

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseApiUrl = this.configService.getApiURI();
    this.apiUrl = this.baseApiUrl + '/GmData/';
    this.apiUrlRm = this.baseApiUrl + '/RmData/';
    this.apiUrlPayment = this.baseApiUrl + '/PaymentDashboard/';
    this.apiUrlZc = this.baseApiUrl + '/ZonalContractor/';
    this.apiUrlUnit = this.baseApiUrl + '/UnitContractor/';
    this.apiUrlZenith = this.baseApiUrl + '/ZenithBank/otherBankTransfer';
    this.apiUrlZenithTransfer = this.baseApiUrl + '/ZenithBank/zenithTransfer';
    this.apiUrlPaymentStatus = this.baseApiUrl + '/PaymentStatus/postSaveData';
    this.apiUrlApplicationForm = this.baseApiUrl + '/ApplicationForm/saveFormData';
    this.apiUrlBillingForm = this.baseApiUrl + '/ApplicationForm/SaveBillingDetails';
    this.apiUrlApplicationFormGet = this.baseApiUrl + '/ApplicationForm/getAllData';
    this.apiUrlGetLGA = this.baseApiUrl + '/ApplicationForm/GetLGA';
    this.apiUrlApplicationFormGetById = this.baseApiUrl + '/ApplicationForm/GetByApplicationId';
    this.apiUrlBillingFormGetById = this.baseApiUrl + '/ApplicationForm/GetBillingDetailsByApplicationId';
    this.apiUrlApplicationFormGetByUserName = this.baseApiUrl + '/ApplicationForm/GetDataByApplicant';
    this.apiUrlAppForm = this.baseApiUrl + '/ApplicationForm/';
    this.apiUrlRegistrationForm = this.baseApiUrl + '/RegistrationForm/saveFormData';
    this.apiUrlNINVerify = this.baseApiUrl + '/RegistrationForm/GetNINData';
    this.apiUrlComapnyVerify = this.baseApiUrl + '/RegistrationForm/GetCompanyData';
    this.apiUrlApplicationFormGetData = this.baseApiUrl + '/ApplicationForm/getGridData';
    this.apiApprovalUrl = this.baseApiUrl + '/WestZonalApprovalGridReport/';
    this.apiRejectUrl = this.baseApiUrl + '/WestZonalRejectGridReport/'
    this.apiSendEmailUrl = this.baseApiUrl + '/ApplicationForm/sendEmailToClient';
    this.apiSendSMSUrl = this.baseApiUrl + '/ApplicationForm/sendSMSToClient';
    var currentUser = JSON.parse(localStorage.getItem('currentClient'));
    this.clientId = currentUser.clientId;

  }


  NasaGetApiCall(type: string) {
    try {
      return this.http.get(this.apiUrl + type);
    }
    catch (Ex) {
      throw Ex;
    }
  }


  ApplicationFormGetApiCall( gridFilter: GridFilterModel) {
    try {
      return this.http.post(this.apiUrlApplicationFormGet  + '/', gridFilter);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  ApplicationFormGetDataApiCall(type: string,gridFilter: GridFilterModel) {
    try {
      return this.http.post(this.apiUrlApplicationFormGetData +'/' + type + '/', gridFilter);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  ApplicationFormGetDataByIdApiCall(id: string) {
    try {
      return this.http.get(this.apiUrlApplicationFormGetById + '/' + id).toPromise();;
    }
    catch (Ex) {
      throw Ex;
    }
  }

  BillingFormGetDataByIdApiCall(id: string) {
    try {
      return this.http.get(this.apiUrlBillingFormGetById + '/' + id).toPromise();;
    }
    catch (Ex) {
      throw Ex;
    }
  }

  ApplicationFormGetDataByUserNameApiCall(userName: string) {
    try {
      return this.http.get(this.apiUrlApplicationFormGetByUserName + '/' + userName).toPromise();;
    }
    catch (Ex) {
      throw Ex;
    }
  }

  GetLGA() {
    try {
      return this.http.get(this.apiUrlGetLGA ).toPromise();;
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaGetApiCallByDateMap(type: string, fromdate: string, todate: string) {

    try {
      return this.http.get(this.baseApiUrl + type + '/' + fromdate + '/' + todate);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  ApprovalGridReportData(type: string, gridFilter: GridFilterModel) {
    try {
      return this.http.post(this.apiApprovalUrl + type + '/', gridFilter);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  RejectGridReportData(type: string, gridFilter: GridFilterModel) {   
    try {
      return this.http.post(this.apiRejectUrl + type + '/', gridFilter);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaGetApiCallByDate(type: string, fromdate: string, todate: string) {

    try {
      return this.http.get(this.apiUrl + type + '/' + fromdate + '/' + todate);
    }
    catch (Ex) {
      throw Ex;
    }
  }


  GetApplicationTypeAPICall(_tblApplicationTypeId: string, type: string) {

    try {
      return this.http.get(this.apiUrlAppForm + type);
    }
    catch (Ex) {
      throw Ex;
    }
  }
  GetDocumentTypeAPICall(_tblApplicationTypeId: string, type: string) {

    try {
      return this.http.get(this.apiUrlAppForm + type);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaGetRmApiCallByLocationId(type: string, fromdate: string, todate: string, LocationId: string) {

    try {
      return this.http.get(this.apiUrlRm + type + '/' + fromdate + '/' + todate + '/' + LocationId);
    }
    catch (Ex) {
      throw Ex;
    }
  }


  NasaGetRmApiCallByDate(type: string, fromdate: string, todate: string) {

    try {
      return this.http.get(this.apiUrlRm + type + '/' + fromdate + '/' + todate + '/');
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaGetRmApiFormData(type: string, gridFilter: GridFilterModel) {
    try {
      return this.http.post(this.apiUrlRm + type + '/', gridFilter);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaOtherBankTransferAPI(body: any) {
    try {
      return this.http.post(this.apiUrlZenith, body);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaPaymentStatusAPI(body: any) {
    try {
      return this.http.post(this.apiUrlPaymentStatus, body);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  IsUniqueIDExists(type: string) {
    try {
      return this.http.get(this.apiUrlPaymentStatus + type);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasazenithTransferAPI(body: any) {
    try {
      return this.http.post(this.apiUrlZenithTransfer, body);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  ApplicationFormAPI(body: any) {
    try {
      return this.http.post(this.apiUrlApplicationForm, body);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  BillingFormAPI(body: any) {
    try {
      return this.http.post(this.apiUrlBillingForm, body);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  RegistrationFormAPI(body: RegistrationFormModel) { 
    try {
      return this.http.post(this.apiUrlRegistrationForm, body);
    }
    catch (Ex) {
      throw Ex;
    }
  }


  NINVerifyAPI(body: RegistrationFormModel) {
    try {
      return this.http.post(this.apiUrlNINVerify, body);
    }
    catch (Ex) {
      throw Ex;
    }
  }


  ComapnyVerifyAPI(body: RegistrationFormModel) {
    try {
      return this.http.post(this.apiUrlComapnyVerify, body);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaGetApiCallByLocationId(type: string, fromdate: string, todate: string, LocationId: string) {

    try {
      return this.http.get(this.apiUrl + type + '/' + fromdate + '/' + todate + '/' + LocationId);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaGetDashboardCount(type: string) {

    try {
      return this.http.get(this.apiUrlRm + type);
    }
    catch (Ex) {
      throw Ex;
    }
  }


  NasaGetRmCount(type: string, LocationId: string) {

    try {
      return this.http.get(this.apiUrlRm + type + '/' + LocationId);
    }
    catch (Ex) {
      throw Ex;
    }
  }



  NasaGetGmCount(type: string, LocationId: string) {

    try {
      return this.http.get(this.apiUrl + type + '/' + LocationId);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaGetGmDashboardCount(type: string) {

    try {
      return this.http.get(this.apiUrl + type);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaGetPaymentApiCallByDate(type: string, fromdate: string, todate: string) {
    try {
      return this.http.get(this.apiUrlPayment + type + '/' + fromdate + '/' + todate + '/');
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaGetZcApiCallByLocationId(type: string, fromdate: string, todate: string, LocationId: string) {
    try {
      return this.http.get(this.apiUrlZc + type + '/' + fromdate + '/' + todate + '/' + LocationId);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaGetZcCount(type: string, LocationId: string) {
    try {
      return this.http.get(this.apiUrlZc + type + '/' + LocationId);
    }
    catch (Ex) {
      throw Ex;
    }
  }


  NasaGetUnitApiCallByLocationId(type: string, fromdate: string, todate: string, LocationId: string) {
    try {
      return this.http.get(this.apiUrlUnit + type + '/' + fromdate + '/' + todate + '/' + LocationId);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaGetUnitCount(type: string, LocationId: string) {
    try {
      return this.http.get(this.apiUrlUnit + type + '/' + LocationId);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  GetBaseUrl() {
    return this.baseApiUrl;
  }

  GetClientId() {
    return this.clientId;
  }

  GetPhotos(photoname: string, Id: string) {
    return this.photourl = "" + this.baseApiUrl + "/Document/retrieveImage?Id=" + Id + "&FileName=" + photoname + "&ClientId=" + this.clientId + ""
  }

  NasaGetUnitDashboardCount(type: string) {

    try {
      return this.http.get(this.apiUrlUnit + type);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaGetZcDashboardCount(type: string) {

    try {
      return this.http.get(this.apiUrlZc + type);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaGetUnitApiCallByDate(type: string, fromdate: string, todate: string) {
    try {
      return this.http.get(this.apiUrlUnit + type + '/' + fromdate + '/' + todate + '/');
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaGetApiFormData(type: string, gridFilter: GridFilterModel) {
    try {
      return this.http.post(this.apiUrl + type + '/', gridFilter);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaGetApprovalFormData(type: string, gridFilter: GridFilterModel) {
    try {
      return this.http.post(this.apiApprovalUrl + type + '/', gridFilter);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaGetApiZcFormData(type: string, gridFilter: GridFilterModel) {
    try {
      return this.http.post(this.apiUrlZc + type + '/', gridFilter);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaGetApiFormDataByLocation(type: string, gridFilter: GridFilterModel, LocationId: string) {
    try {
      return this.http.post(this.apiUrl + type + '/' + LocationId + '/', gridFilter);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaGetRmApiFormDataByLocation(type: string, gridFilter: GridFilterModel, LocationId: string) {
    try {
      return this.http.post(this.apiUrlRm + type + '/' + LocationId + '/', gridFilter);
    }
    catch (Ex) {
      throw Ex;
    }
  }


  NasaGetApiZcFormDataByLocationId(type: string, gridFilter: GridFilterModel, LocationId: string) {
    try {
      return this.http.post(this.apiUrlZc + type + '/' + LocationId + '/', gridFilter);
    }
    catch (Ex) {
      throw Ex;
    }
  }
  NasaGetUcApiFormDataByLocation(type: string, gridFilter: GridFilterModel, LocationId: string) {
    try {
      return this.http.post(this.apiUrlUnit + type + '/' + LocationId + '/', gridFilter);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  NasaGetApiUcFormData(type: string, gridFilter: GridFilterModel) {
    try {
      return this.http.post(this.apiUrlUnit + type + '/', gridFilter);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  SendEmailApi(body: any){
    try {
      return this.http.post(this.apiSendEmailUrl, body);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  SendSMSApi(body: any){
    try {
      return this.http.post(this.apiSendSMSUrl, body);
    }
    catch (Ex) {
      throw Ex;
    }
  }
}

